export default __webpack_public_path__ + "static/media/service.c2f8a01a.png";